import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'core/common/hooks';
import { FeaturesPayload } from 'core/feature-flags/entities';
import { getFeatureFlagsConfig, loadFeatures } from 'core/feature-flags/store';
import { FunnelConfig } from '../entities';
import { loadFunnelConfig, updateConfig } from '../store/actions';
import { getFunnelConfig } from '../store/selectors';

type Params = {
  funnelConfig: FunnelConfig | null;
  featuresPayload: FeaturesPayload | null;
  funnelId: string;
};

/** @deprecated. Use "useFunnelConfig" instead  **/
export const useFunnelConfigDeprecated = ({ funnelConfig, featuresPayload, funnelId }: Params) => {
  // const router = useRouter();
  const dispatch = useDispatch();

  const { config: storageConfig, loadingStatus } = useSelector(getFunnelConfig);
  const { config: storageFeatureFlagsConfig, loadingStatus: featureFlagsLoadingStatus } =
    useSelector(getFeatureFlagsConfig);

  // const language = router.locale as Languages;

  useEffect(() => {
    // Update Redux store with config from "getStaticProps"
    if (funnelConfig) {
      dispatch(updateConfig(funnelConfig));
      return;
    }

    // Load config (for direct navigation by URL)
    if (!funnelConfig && !storageConfig) {
      dispatch(loadFunnelConfig({ funnelId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (storageFeatureFlagsConfig) {
      return;
    }

    const options = featuresPayload ? { payload: featuresPayload } : {};

    dispatch(loadFeatures(options));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    config: funnelConfig ?? storageConfig,
    loadingStatus,
    featureFlagsConfig: storageFeatureFlagsConfig,
    featureFlagsLoadingStatus,
  };
};
